import { Textinput } from './Textinput';

export type { TypeTextinputProps } from './types';
export default Textinput;
